import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useStore, useTheme } from "@/comn/hooks";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    APIS,
    SF_CSTMSAUTH_SRCH,
    SG_CSTM_USR_EXCEL_LIST,
    SG_CSTM_USR_LIST,
    URLS,
    BASE,
} from "@/tra/tancis/ptli/ptl/cstmauth/service/PtliCstmAuthService";
import { comnUtils } from "@/comn/utils";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

/*
 * Custom Office User Auth Management List
 * !== 세관 사용자 권한 관리 목록 ==!
 */
export const PTLI1007001Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const modal = useModal();
    const { theme } = useTheme();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const [load, setLoad] = useState(false);

    const form = {
        cstmAuthSrch: useForm({ defaultSchema: SF_CSTMSAUTH_SRCH }),
    };

    const ExcelDown = !!String(form.cstmAuthSrch.getValue("cstmCd") ?? "").trim();

    const grid = {
        gridCstmUsrList: useGrid({
            defaultSchema: SG_CSTM_USR_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        gridCstmUsrExcelList: useGrid({
            defaultSchema: SG_CSTM_USR_EXCEL_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getCstmUsrList: useFetch({
            api: (page = grid.gridCstmUsrList.page, size = grid.gridCstmUsrList.size) =>
                APIS.getCstmUsrList(form.cstmAuthSrch.getValues(), page, size),
            enabled: form.cstmAuthSrch.isSubmitted,
            key: [grid.gridCstmUsrList.page, grid.gridCstmUsrList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    ...pgeStore,
                    form: form.cstmAuthSrch.getValues(),
                    page: grid.gridCstmUsrList.page,
                    size: grid.gridCstmUsrList.size,
                });
            },
            onError: () => modal.openModal({ content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        // Get a excel list of Customs Officer. !== 세관직원 엑셀 목록을 조회한다. ==!
        getCstmUsrExcelList: useFetch({
            api: (data: any) => (load ? APIS.getCstmUsrExcelList(data) : null),
            enabled: comnUtils.isEmpty(form.cstmAuthSrch.errors),
            onSuccess: () => {
                if (load) {
                    grid.gridCstmUsrExcelList.exportExcel({
                        // Internal Portal Customs User Information !== 내부 포털_세관_사용자 정보 ==!
                        excelName: `${t("L_INT_PTL")}_Internal User Authority_${t("T_USR_INFO")}_${dayjs().format(
                            "DD/MM/YYYY HHmm",
                        )}`,
                        sheetName: "Sheet1",
                    });
                }
                setLoad(false);
            },
            onError: () => {},
            showToast: true,
        }),
    };

    const render = {
        cstmUsrList: {
            cell: {
                usrNm: (props: any) => {
                    const { value, rowValues } = props;
                    return <Link to={`${URLS.ptli1007002s}/${rowValues.usrDmnId}`}>{value}</Link>;
                },
            },
        },
    };

    const handler = {
        onSrchClick: form.cstmAuthSrch.handleSubmit(() => fetch.getCstmUsrList.fetch()),
        onClear: () => {
            form.cstmAuthSrch.clearValues();
            grid.gridCstmUsrList.getData().length > 0 && grid.gridCstmUsrList.clearData();
        },

        // onExcelDownClick: () => {
        //     // 서버에서 엑셀 파일(blob) 내려주는 엔드포인트
        //     // BE 규약에 맞춰 경로만 맞춰주세요. 예) /cstm-usr/excel-down
        //     const downUrl = `${BASE.api}/cstm-usr/excel`;
        //     const params = form.cstmAuthSrch.getValues();

        //     // 서비스에 추가해 둔 다운로드 함수 호출
        //     APIS.saveExcelDownload(downUrl, params);
        // },
    };

    useEffect(() => {
        handler.onSrchClick(pgeStore?.page);
    }, []);

    useEffect(() => {
        pgeStore?.form && form.cstmAuthSrch.setValues(pgeStore.form);
        pgeStore?.form && handler.onSrchClick();
    }, [theme]);

    useEffect(() => {
        const store = getStore(pgeUid);
        if (!comnUtils.isEmpty(store) || load) {
            fetch.getCstmUsrExcelList.fetch(store.form);
        }
    }, [load]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.cstmAuthSrch.schema.cstmCd} />
                            <Group.Control {...form.cstmAuthSrch.schema.cstmOfcrNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmAuthSrch.schema.usrDmnId} />
                            <Group.Control {...form.cstmAuthSrch.schema.cstmOfcrNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmAuthSrch.schema.authId} />
                            <Group.Control {...form.cstmAuthSrch.schema.authNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmAuthSrch.schema.usrStatCd} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={handler.onClear} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onSrchClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    {
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="excelDown"
                                    onClick={() => {
                                        setLoad(true);
                                    }}

                                    //onClick={handler.onExcelDownClick}
                                ></Button>
                            </Layout.Left>
                        </Layout>
                    }
                    <Group.Title title={"T_CSTM_OFCR_LIST"} />
                    <Grid
                        {...grid.gridCstmUsrList.grid}
                        data={fetch.getCstmUsrList.data?.cstmUsrList}
                        render={render.cstmUsrList}
                    />
                </Group.Body>
            </Group>
            <Group hidden>
                <Grid {...grid.gridCstmUsrExcelList.grid} data={fetch.getCstmUsrExcelList.data?.cstmUsrExcelList} />
            </Group>
        </Page>
    );
};
